export default __webpack_public_path__ + "static/media/01a_fold-1.f1493cf7.mp4";